import { render } from "./AlbumView.vue?vue&type=template&id=5360b95c&scoped=true"
import script from "./AlbumView.vue?vue&type=script&lang=js"
export * from "./AlbumView.vue?vue&type=script&lang=js"

import "./AlbumView.vue?vue&type=style&index=0&id=5360b95c&scoped=true&lang=css"

import exportComponent from "/Applications/MAMP/hosts/mageix.ch/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5360b95c"]])

export default __exports__